module.exports = __webpack_public_path__ + "img/offlineOrder-pic.442946a0.png";